import {
  Button, Dialog, DialogContent, TextField,
} from '@mui/material'
import React, { useState } from 'react'

const PasswordPrompt = ({
  prompt: { title = '', message = '', onOk = async () => {} },
  setShowPrompt,
}) => {
  const [password, setPassword] = useState('')
  const onOkHandler = async () => {
    const error = await onOk(password)
    if (error !== true) setShowPrompt(null)
  }
  return (
    <Dialog open>
      <DialogContent
        sx={{ padding: 'max(3vw,3vh)' }}
        className='flex flex-col justify-center items-center gap-6'
      >
        <div className='flex flex-col gap-2'>
          {title && <h2 className='text-center'>{title}</h2>}
          {message && <span className='underline text-center'>{message}</span>}
        </div>
        <TextField
          label='Ingrese su contraseña'
          className='self-stretch'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type='password'
          variant='filled'
        />
        <div className='flex gap-4'>
          <Button onClick={() => setShowPrompt(null)}>
            Cancelar
          </Button>
          <Button onClick={onOkHandler}>
            Ok
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default PasswordPrompt
